import React from "react";
import gymMan from "../image/gym-man.gif";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <>
      <section className="error-page-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h3 className="mb-5">
                We are unable to process your request, sorry for inconvenience!
              </h3>
              <span className="fs-5 mb-3">
                Here are some useful links instead:{" "}
              </span>
              <ul className="error-page-link">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-5">
              <LazyLoadImage
                src={gymMan}
                className="gym-man-gif"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
